
import React from 'react';
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface SearchBoxProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  totalCount: number;
  filteredCount: number;
}

const SearchBox = ({ searchTerm, setSearchTerm, totalCount, filteredCount }: SearchBoxProps) => {
  return (
    <div className="mb-4 relative">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          className="pl-10"
          placeholder="Search by product name, ID, or price..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
      <p className="text-xs text-muted-foreground mt-1">
        Showing {filteredCount} of {totalCount} products
      </p>
    </div>
  );
};

export default SearchBox;
